import React from 'react';

import axios from 'axios';
import queryString from 'query-string';


import constants from './util/constants';

const { API_BASE_URL } = constants;

export default function wrapWithApiData(options, WrappedComponent) {
  // Preserve the original default params (e.g. fromdate/todate) so the
  // "reset filters" logic below can restore them instead of dropping them.
  const defaultOrderSearchParams = options?.apiCalls?.orderSearchData?.params;

  return class withApiData extends React.Component {
    constructor(props) {
      super(props);

      this.reload = this.reload.bind(this);
      this.loadData = this.loadData.bind(this);

      this.state = {
        dataProps: null,
        isLoading: true,
      }
    }

    componentWillUnmount() {
      //if orderSearchData is filtered, reset data when other page is clicked.
      if(options && options.apiCalls && options.apiCalls.orderSearchData){
         options = { apiCalls: { 
          orderSearchData: { url: 'Order/GetOrderData2', params: defaultOrderSearchParams }
          }
        } 
      }
    }
  

    componentDidMount() {
      const { apiToken, setApiToken } = this.props;

      if(apiToken) {
        this.loadData();
      }

      if(!!setApiToken) {
        setApiToken(apiToken);
      }
    }


    reload(additionalOptions) {
      this.setState({
        isLoading: true,
      });

      //if orderSearchData is filtered, reset data on reload.
      if(options && options.apiCalls && options.apiCalls.orderSearchData){
        options = { apiCalls: { 
         orderSearchData: { url: 'Order/GetOrderData2', params: defaultOrderSearchParams }
         }
       } 
      }
      
      this.loadData(additionalOptions);
    }


    /**
     * Takes a parameter called additionalOptions, to extend component with additional properties or overwrite previous ones
     * @param {*} additionalOptions 
     */
    loadData(additionalOptions) {
      const calls = [];
      
      const { apiToken } = this.props;

      let apiCalls = options.apiCalls;
      let additionalApiCalls = {};

      if(additionalOptions && additionalOptions.apiCalls) {
        additionalApiCalls = additionalOptions.apiCalls;
      }
      
      if(additionalApiCalls) {
        for(const v in additionalApiCalls) {
          if(additionalApiCalls.hasOwnProperty(v)) {
            if(additionalApiCalls[v].url) {
              apiCalls[v].url = additionalApiCalls[v].url;
            }

            if(additionalApiCalls[v].params) {
              apiCalls[v].params = additionalApiCalls[v].params;
            }
          }
        }
      }

      for(const va in apiCalls) {
        if(apiCalls.hasOwnProperty(va)) {
          const header = { 
            'Authorization': 'Bearer ' + apiToken,
            'Cache-Control': 'no-cache'
          };
          
          if(apiCalls[va].params) {
            calls.push(axios.get(API_BASE_URL + apiCalls[va].url + '/?' + queryString.stringify(apiCalls[va].params), { name: va, headers: header }));
          } else {
            calls.push(axios.get(API_BASE_URL + apiCalls[va].url, { name: va, headers: header }));
          }
        }
      }
    
      let dataProps = {};
      let additionalExtraProps = {};

      if(additionalOptions && additionalOptions.extraProps) {
        additionalExtraProps = additionalOptions.extraProps;
      }
      
      axios.all(calls)
      .then(results => {
        results.forEach(r => {
          dataProps[r.config.name] = r.data;
        });
    
        this.setState({
          dataProps: dataProps,
          isLoading: false,
        });

        if(additionalOptions && additionalOptions.callback) {
          additionalOptions.callback(true);
        };
      })
      .catch(response => {
        if(additionalOptions && additionalOptions.callback) {
          additionalOptions.callback(false);
        }; 
      });

      this.setState({
        additionalExtraProps,
      });
    }

    render() {
      const { dataProps, additionalExtraProps } = this.state;
      const extraProps = options.extraProps || {};

      if(this.state.isLoading) {
        return <WrappedComponent {...this.props} />
      } else {
        return <WrappedComponent {...this.props} {...dataProps} reloadData={this.reload} {...extraProps} {...additionalExtraProps} />
      }
    }
  }
}